import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

export const HsnSacSearch = ({ value, onChange, onPick, kind = "", className = "", testId = "hsn-sac-search", placeholder = "Code or description" }) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const box = useRef(null);

  useEffect(() => {
    if (!open) { return undefined; }
    const t = setTimeout(() => {
      api.get("/hsn-sac/search", { params: { q, kind } }).then((r) => setRows(r.data)).catch(() => setRows([]));
    }, 200);
    return () => clearTimeout(t);
  }, [q, kind, open]);

  useEffect(() => {
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className="relative" ref={box}>
      <Input value={value || ""} placeholder={placeholder} className={`rounded-sm font-mono ${className}`} data-testid={testId}
        onFocus={() => { setQ(value || ""); setOpen(true); }}
        onChange={(e) => { onChange(e.target.value); setQ(e.target.value); setOpen(true); }} />
      {open && rows.length > 0 && (
        <div className="absolute z-50 mt-1 w-[min(24rem,85vw)] max-h-60 overflow-y-auto bg-popover border rounded-sm shadow-lg" data-testid={`${testId}-list`}>
          {rows.map((r) => (
            <button key={r.code} type="button" data-testid={`${testId}-opt-${r.code}`}
              className="w-full text-left px-2 py-1.5 text-xs hover:bg-muted flex items-center gap-2"
              onMouseDown={(e) => { e.preventDefault(); onPick(r); setOpen(false); }}>
              <span className="font-mono w-16 shrink-0">{r.code}</span>
              <span className="flex-1 line-clamp-2" title={r.description}>{r.description}</span>
              <span className="tabular-nums text-muted-foreground">{r.gst_rate == null ? "—" : `${r.gst_rate}%`}</span>
            </button>
          ))}
          <div className="px-2 py-1 text-[10px] text-muted-foreground border-t">Official GST HSN/SAC list. Rates shown are usual rates (— = check rate). Confirm for your supply.</div>
        </div>
      )}
    </div>
  );
};
